import { render, staticRenderFns } from "./PlanejamentoAcaoForm.vue?vue&type=template&id=19377976"
import script from "./PlanejamentoAcaoForm.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoForm.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoForm.vue?vue&type=style&index=0&id=19377976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports